import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import phoneFormatter from 'phone-formatter';

export default class Footer extends Component {
  static propTypes = {
    agencyName: PropTypes.string,
    phoneNumber: PropTypes.string.isRequired,
    email: PropTypes.string,
    website: PropTypes.string
  };

  render() {
    // const { agencyName, phoneNumber, email, website } = this.props;
    return (
      // TODO: fix this later as per the product requirement
      <footer className="usa-footer usa-footer--slim common-footer">
        {/* content removed temporarily as part ELP-12979*/}
        {/*<p className="mb-0"><a href={website}>{agencyName}</a><span className='m-2 common-footer__spacer'>|</span></p>*/}
        {/*<p className="mb-0"><a href={`tel:${phoneNumber}`}>{phoneFormatter.format(phoneNumber, '(NNN) NNN-NNNN')}</a><span className='m-2 common-footer__spacer'>|</span></p>*/}
        {/*<p className="mb-0"><a href={`mailto:${email}`}>{email}</a></p>*/}
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/Footer.js